import { featureNews, siteStats } from '@/mocks/gossip';

export default function Hero() {
  const lead = featureNews[0];
  const rest = featureNews.slice(1, 5);

  return (
    <section
      id="top"
      className="relative overflow-hidden border-b border-background-200 bg-gradient-to-br from-background-50 via-background-100 to-background-200"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.5]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 85% 15%, oklch(var(--primary-500) / 0.08), transparent 34%), radial-gradient(circle at 8% 80%, oklch(var(--accent-500) / 0.08), transparent 32%)',
        }}
      />
      <div className="relative mx-auto max-w-[1280px] px-4 pt-28 pb-14 md:px-6 md:pt-36 md:pb-20">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start">
          {/* 左：置顶热瓜 */}
          <div className="w-full flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold whitespace-nowrap text-background-50">
                <i className="ri-fire-fill" />
                今日置顶热瓜
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium whitespace-nowrap text-secondary-900">
                <i className="ri-verified-badge-line" />
                {lead.badge}
              </span>
            </div>
            <h1 className="font-heading mt-5 text-3xl leading-snug font-bold text-foreground-950 md:text-[42px] md:leading-[1.25]">
              新实锤新证据持续上线
              <br />
              从蛛丝马迹中还原事件真相
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
              每日滚动更新最新截图、录音、视频与线索，所有材料均标注核验状态。点击任意条目，即可查看该事件当下已曝光的最全实锤档案。
            </p>

            <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
              <a
                href="#zhengju"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-search-line" />
                检索全部证据
              </a>
              <a
                href="#zhuizong"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-secondary-100 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                <i className="ri-refresh-line" />
                查看最新追踪
              </a>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {siteStats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200/70 bg-background-50/70 px-4 py-3"
                >
                  <div className="font-label text-2xl font-bold text-primary-600">{s.value}</div>
                  <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 右：聚焦卡片 */}
          <div className="w-full max-w-md lg:w-[400px]">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <a href="#zhuizong" className="block">
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=stylized%20editorial%20documentary%20collage%20of%20magnifying%20glass%20timeline%20evidence%20folder%20and%20playback%20icons%2C%20warm%20cream%20paper%20background%20with%20bold%20coral%20and%20jade%20graphic%20shapes%2C%20media%20investigation%20magazine%20cover%20aesthetic%2C%20flat%20vector%20illustration%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=gossip-hero-lead&orientation=landscape"
                    alt="事件调查取证与证据归档场景插画"
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium whitespace-nowrap text-background-50 backdrop-blur">
                    <i className="ri-flashlight-fill" />
                    置顶
                  </span>
                </div>
              </a>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
                    {lead.tag}
                  </span>
                  <span>{lead.category}</span>
                  <span className="mx-1">·</span>
                  <span>{lead.time}</span>
                </div>
                <a href="#zhuizong">
                  <h2 className="font-heading mt-2.5 text-lg leading-snug font-bold text-foreground-950 transition-colors hover:text-primary-700">
                    {lead.title}
                  </h2>
                </a>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  将多个平台的公开素材按时间轴对齐，交叉印证后梳理出完整的事件推进脉络。
                </p>
              </div>
            </div>

            <ul className="mt-3 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {rest.map((item, i) => (
                <li key={item.id}>
                  <a
                    href="#zhuizong"
                    className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-secondary-50"
                  >
                    <span className="font-label w-6 shrink-0 text-center text-base font-bold text-primary-300">
                      {i + 1}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="inline-flex shrink-0 items-center rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {item.tag}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}